import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApprovalFlowModal } from '@/accessControl/ApprovalFlowModal.molecule';
import { useApprovalFlows } from '@/accessControl/hooks/useApprovalFlows.hooks';
import { isApprovalFlowsEnabled } from '@/services/systemConfiguration.utilities';
import { errorToast, successToast } from '@/utilities/toast.utilities';
import { useApiCreateApprovalFlowAssignmentMutation } from '@seeqdev/api/endpoint/ApprovalFlowAssignmentsApi';
import { useApiCreateApprovalFlowAttachmentMutation } from '@seeqdev/api/endpoint/ApprovalFlowAttachmentsApi';
import { Button, ButtonWithDropdown, Icon } from '@seeqdev/qomponents';

export const ApprovalFlowHeaderControl = () => {
  const { t } = useTranslation();
  const [showApplyModal, setShowApplyModal] = useState(false);
  const { approvalFlow, nextStep, showApplyBtn, showStepDropdown, workbookId } = useApprovalFlows();
  const approvalFlowsEnabled = isApprovalFlowsEnabled();

  const { mutate: createApprovalFlowAttachment, isPending } = useApiCreateApprovalFlowAttachmentMutation({
    onSuccess: () => {
      successToast({ messageKey: 'APPROVAL_FLOWS.APPLY_SUCCESS' });
      setShowApplyModal(false);
    },
    onError: (error) => {
      errorToast({ httpResponseOrError: error });
    },
  });

  const { mutate: createAssignment } = useApiCreateApprovalFlowAssignmentMutation({});

  const applyApprovalFlow = async () => {
    if (showApplyBtn) {
      return createApprovalFlowAttachment([{ itemId: workbookId }, { flowId: approvalFlow?.id }]);
    }
    setShowApplyModal(false);
  };

  if (!approvalFlowsEnabled || (!showApplyBtn && !showStepDropdown)) {
    return null;
  }

  return (
    <>
      {showApplyBtn ? (
        <Button
          size="xs"
          label={t('APPROVAL_FLOWS.APPLY_TITLE')}
          onClick={() => setShowApplyModal(true)}
          testId="applyApprovalFlow"
          variant="outline"
        />
      ) : showStepDropdown ? (
        <ButtonWithDropdown
          label={
            <>
              <span>{nextStep?.name}</span>
              <Icon
                icon="fa-chevron-down"
                testId="approvalFlowStepChevron"
                type="inherit"
                extraClassNames="tw:pl-0.5"
              />
            </>
          }
          size="xs"
          data-testid="approvalFlowStep"
          dropdownItems={[
            {
              label: t('APPROVAL_FLOWS.OPTIONS.APPROVE_STEP'),
              disabled: !nextStep?.permissions.manage,
              onClick: () => {
                createAssignment([{ stepId: nextStep?.id, itemId: workbookId }, { flowId: approvalFlow?.id }]);
              },
            },
            {
              label: t('APPROVAL_FLOWS.OPTIONS.VIEW_STEPS'),
              onClick: () => {
                setShowApplyModal(true);
              },
            },
          ]}
        />
      ) : null}
      {showApplyModal && (
        <ApprovalFlowModal
          isApplyingFlow={showApplyBtn}
          approvalFlow={approvalFlow}
          isApplying={isPending}
          onSubmit={applyApprovalFlow}
          onClose={() => setShowApplyModal(false)}
        />
      )}
    </>
  );
};
